<template>
	<!-- :style="{backgroundImage:'url(' + forground + ')'}" -->
    <div
        class="questionnaire"
        
        v-if="!begin && isPhone"
        @click="onShowClick"
    >
        <div class="cover-image">
            <img :src="forground" />
        </div>
    </div>
    <div
        class="questionnaire"
        style="background-size: cover;"
        :style="{backgroundImage:'url(' + background + ')'}"
        v-else
    >
        <div class="banner" v-if="!isPhone" :style="{backgroundImage:'url(' + background + ')'}" />
        <div class="container">
            <div class="question-title">{{title}}</div>
            <div class="question-subtitle">{{description}}</div>
            <div class="question-content" v-if="!show">
                <template v-for="(item, index) in question">
                    <Question
                        :id="'question'+(index+1)"
                        :index="index + 1"
                        :key="index"
                        :title="item.title"
                        :class="{disabled: !(enabledQid[item.sort] && enabledQid[item.sort].enabled)}"
                        v-model="answer[item.id]"
                        @input="val => handleAnswer(item, val)"
                        v-if="item.type == '1'"
                    />
                    <SingleSelect
                        :id="'question'+(index+1)"
                        :index="index + 1"
                        :key="index"
                        :title="item.title"
                        :options="item.selection"
                        :class="{disabled: !(enabledQid[item.sort] && enabledQid[item.sort].enabled)}"
                        v-model="answer[item.id]"
                        @input="(val, next) => handleAnswer(item, val, next)"
                        v-if="item.type == '2'"
                    />
                    <!-- hide:ishide(index) -->
                    <MultiSelect
                        :id="'question'+(index+1)"
                        :index="index + 1"
                        :key="index"
                        :title="item.title"
                        :options="item.selection"
                        :max="item.selection_max"
                        :class="{disabled: !(enabledQid[item.sort] && enabledQid[item.sort].enabled)}"
                        v-model="answer[item.id]"
                        @input="val => handleAnswer(item, val)"
                        v-if="item.type == '3'"
                    />
                    <Dropdown
                        :id="'question'+(index+1)"
                        :index="index + 1"
                        :key="index"
                        :title="item.title"
                        :options="item.selection"
                        :class="{disabled: !(enabledQid[item.sort] && enabledQid[item.sort].enabled)}"
                        v-model="answer[item.id]"
                        @input="(val, next) => handleAnswer(item, val, next)"
                        v-if="item.type == '4'"
                    />
                    <Upload
                        :id="'question'+(index+1)"
                        :index="index + 1"
                        :key="index"
                        :title="item.title"
                        :class="{disabled: !(enabledQid[item.sort] && enabledQid[item.sort].enabled)}"
                        v-model="answer[item.id]"
                        @input="(val, next) => handleAnswer(item, val, next)"
                        v-if="item.type == '5'"
                    />
                </template>
                <div class="question-commit">
                    <div class="commit-btn" :style="{background: color}" @click="onCommitClick">提 交</div>
                </div>
            </div>

            <div class="question-result" v-if="show">
                <div class="result-panel">
                    <img src="../assets/success.png" />
                    <div class="result-content">感谢您的回答及宝贵时间，</div>
                    <div class="result-content">我们将认真对待您的建议！</div>
                    <div class="result-btn" @click="onFinishClick">确 定</div>
                </div>
            </div>
        </div>
        <div class="spinner-container" v-if="showSpinner">
            <van-loading size="24" color="#005BA1" text-size="16" text-color="#666">上传中...</van-loading>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import Question from "@/components/Question.vue";
import SingleSelect from "@/components/SingleSelect.vue";
import MultiSelect from "@/components/MultiSelect.vue";
import Dropdown from "@/components/Dropdown.vue";
import Upload from "@/components/Upload.vue";
import { MessageBox } from "mint-ui";
import { Loading } from "vant";
import configWxShare from "../helpers/configWxShare";
import "@/assets/css/pc.scss";

export default {
    name: "questionnaire",
    components: {
        Question,
        SingleSelect,
        MultiSelect,
        Dropdown,
        Upload,
        "van-loading": Loading
    },
    data() {
        return {
            pid: 0,
            qid: 0,
            begin: false,
            show: false,
            title: "",
            description: "",
            color: "",
            forground: "",
            background: "",
            running: "0",
            question: [],
            answer: [],
            enabledQid: {},
            photoList: {}, // 存放上传图片
            showSpinner: false, // 加载动画
            notFilled: "" // 未填写的题号
        };
    },
    computed: {
        questionMap() {
            return this.question.reduce(
                (res, item) => ({ ...res, [item.sort]: item }),
                {}
            );
        },
        isPhone() {
            return document.documentElement.clientWidth < 800 ? true : false;
        }
    },
    created() {
        this.pid = this.$route.query.pid;
        this.qid = this.$route.query.qid;
        console.log(this.pid);

        var self = this;
        $.ajax({
            url:
                "https://evp.51job.com/51job/api/51miniadmin/h5.php?projectid=" +
                this.pid +
                "&action=questionnaire_config&qid=" +
                this.qid,
            type: "POST",
            dataType: "json",
            success: function(data) {
                console.log(data);
                if (data.data != null) {
                    self.color = data.data.bg_color;
                    self.forground =
                        "https://evp.51job.com/51job/api/51miniadmin/" +
                        data.data.hp_pic;
                    let background = self.isPhone
                        ? data.data.bg_pic
                        : data.data.pc_header_logo;
                    self.background =
                        "https://evp.51job.com/51job/api/51miniadmin/" +
                        background;
                    self.title = data.questionnaire.title;
                    self.description = data.questionnaire.memo;
                    self.running = data.questionnaire.is_running;
                    // 配置微信转发
                    configWxShare(
                        data.data.wx_title,
                        data.data.wx_desc,
                        data.data.wx_logo
                    );
                    document.title = data.questionnaire.title;
                }
            }
        });
        $.ajax({
            url:
                "https://evp.51job.com/51job/api/51miniadmin/h5.php?projectid=" +
                this.pid +
                "&action=questionnaire_list&qid=" +
                this.qid,
            type: "POST",
            dataType: "json",
            success: function(data) {
                if (data.data != null) {
                    self.question = data.data;
                    console.log(data);

                    var array = {};
                    for (var i = 0; i < data.data.length; i++) {
                        array[data.data[i].id] = "";
                    }
                    self.answer = array;

                    // 初始化可答题map
                    self.enabledQid[self.question[0].sort] = {
                        enabled: true,
                        next:
                            self.question[0].goto === "0"
                                ? 2
                                : self.question[0].goto,
                        id: self.question[0].id,
                        hide: false,
                        type: self.question[0].type,
                        val: ""
                    };
                }
            }
        });
    },
    mounted() {
			
        this.isPhone &&
            this.$("body").on("blur", "input", () => {
                window.scroll(0, 0);
                $(document).scrollTop(0);
            });
    },
    methods: {
        onShowClick: function(e) {
            this.begin = true;
        },
        isFinished() {
            //this.enabledQid["15"].next = 17;
            console.log(`this.enabledQid`, this.enabledQid);
            console.log(`this.enabledQid`, this.enabledQid["1"]);
            const _isFinished = item => {
                // console.log("题数",Object.keys(this.answer).length+1);
                if (!item || !item.val.length) {
                    this.notFilled =
                        this.question.findIndex(e => e.id === item.id) + 1;
                    return false;
                } else {
                    if (Number(item.next) > Object.keys(this.answer).length + 1)
                        return true;
                    console.log(`next`, item.next);
                    return _isFinished(this.enabledQid[item.next]);
                }
            };
            return _isFinished(this.enabledQid["1"]);
        },
        onCommitClick: function(e) {
            // 判断是否全部填写
            if (!this.isFinished()) {
                MessageBox.alert(
                    `第${this.notFilled}题未填写，请填写完整信息`,
                    "注意"
                );
                return;
            }

            var self = this;
            try {
                MessageBox.confirm("请确认提交信息是否正确!")
                    .then(function() {
                        // Indicator.open("上传中...");
                        self.showSpinner = true;
                        setTimeout(() => {
                            console.log("设置刷新");
                            self.commitAnswer();
                        }, 100);
                    })
                    .catch(function(err) {
                        console.log(err);
                    });
            } catch (e) {
                console.log(e);
            }
        },

        nextKey(from, to) {
            return to === "0" ? parseInt(from) + 1 : parseInt(to);
        },
        enableList(key) {
            // 递归开启
            let callCnt = 0;
            const _enable = (key, map) => {
                if (map[key]) {
                    map[key].enabled = true;
                    // 环检测
                    if (callCnt <= Object.keys(map).length) {
                        callCnt++;
                        if (map[key].val) _enable(map[key].next, map);
                    } else {
                        MessageBox.alert(
                            "问卷出现环路径问题，请保证逻辑顺利",
                            "注意"
                        );
                    }
                }
            };
            _enable(key, this.enabledQid);
        },
        disableList(key) {
            // 递归禁用
            let callCnt = 0;
            const _disable = (key, map) => {
                if (map[key]) {
                    map[key].enabled = false;
                    // 环检测
                    if (callCnt <= Object.keys(map).length) {
                        callCnt++;
                        _disable(map[key].next, map);
                    } else {
                        MessageBox.alert(
                            "问卷出现环路径问题，请保证逻辑顺利",
                            "注意"
                        );
                    }
                }
            };
            _disable(key, this.enabledQid);
        },
        handleAnswer(item, val, _next) {
            // next发生改变则关闭 lastNext 子链, 并赋值next
            const lastNext = this.enabledQid[item.sort].next;

            // 记录数值修改
            this.enabledQid[item.sort].val = val;

            if (_next && lastNext && lastNext !== _next) {
                this.disableList(lastNext);
                this.enabledQid[item.sort].next = this.nextKey(
                    item.sort,
                    _next
                );
            }
            // 计算next
            const next = this.nextKey(item.sort, _next || item.goto);
            console.log(next, "next");

            // 跳转到下一题
            if (item.type !== "3" && next < 200) {
                document.getElementById("question" + next).scrollIntoView();
            }

            if (val) {
                // 判断 next 是否为自身
                if (String(next) === item.sort) return;
                // 开启 next 可编辑状态
                this.enabledQid[next] = this.enabledQid[next] || {
                    id: this.questionMap[next] && this.questionMap[next].id,
                    enabled: true,
                    next: this.nextKey(
                        next,
                        this.questionMap[next]
                            ? this.questionMap[next].goto
                            : "0"
                    ),
                    val: "",
                    type: this.questionMap[next] && this.questionMap[next].type
                };
                this.enableList(next);
            } else {
                // 关闭可编辑状态
                this.disableList(next);
            }
        },
        getAnswer() {
            let answer = {};
            let key = "1";
            while (this.enabledQid[key]) {
                const question = this.enabledQid[key];
                if (question.id && question.val && question.type !== "5") {
                    answer[question.id] = question.val;
                }
                if (question.id && question.val && question.type === "5") {
                    this.photoList[question.id] = question.val;
                }
                key = question.next;
            }
            return answer;
        },
        commitAnswer: function() {
            let data = this.getAnswer();
            let photoList = this.photoList;
            var self = this;
            for (let key in photoList) {
                let list = photoList[key];
                for (let i = 0; i < list.length; i++) {
                    this.photoUpLoad(list[i].content, key, i);
                }
            }
            data = JSON.stringify({ ...data, ...this.photoList });
            $.ajax({
                url:
                    "https://evp.51job.com/51job/api/51miniadmin/h5.php?projectid=" +
                    this.pid +
                    "&action=questionnaire_user_add&qid=" +
                    this.qid,
                type: "POST",
                async: false,
                data: { selection_all: data },
                dataType: "json",
                success: function(data) {
                    if (data.code == 1) {
                        // Indicator.close();
                        self.showSpinner = false;
                        self.show = true;
                    }
                }
            });
        },
        // 单张图片上传
        photoUpLoad(item, id, index) {
            $.ajax({
                url:
                    "https://evp.51job.com/51job/api/1.0/index.php/minirsshop/index/photoupload?pid=" +
                    this.pid +
                    "&qid=" +
                    this.qid,
                type: "POST",
                async: false,
                data: { file: item },
                dataType: "json",
                success: res => {
                    this.photoList[id][index] = res.data.url;
                }
            });
        },
        onFinishClick: function() {
            // this.answer = [];
            // this.show = false;
            // this.begin = false;
            location.reload();
        },
        // 隐藏不需要回答的题
        ishide(index) {
            let item = this.enabledQid[7];
            if (
                item &&
                item.val === "否" &&
                [7, 8, 9, 10, 11, 12].includes(index)
            ) {
                return true;
            }
            return false;
        }
    }
};
</script>
<style lang="scss">
@media screen and (max-width: 800px) {
    .questionnaire {
        display: flex;
        flex-direction: column;
        background-repeat: no-repeat;
        background-size: 100%;
        height: 100%;
        width: 7.5rem;
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        overflow: hidden;

        .cover-image {
            width: 100%;
            height: 100%;
            overflow-x: hidden;
            overflow-y: auto;

            img {
                width: 100%;
            }
        }
    }
    .container {
        width: 100%;
        height: 100%;
    }
    .question-title {
        width: 100%;
        padding: 60px 0 0;
        height: 60px;
        font-size: 38px;
        color: #fff;
        text-align: center;
    }
    .question-subtitle {
        width: calc(100% - 80px);
        padding: 40px;
        height: 80px;
        font-size: 32px;
        color: #fff;
        text-align: center;
    }

    .question-content {
        width: calc(100% - 40px);
        height: calc(100% - 300px);
        margin: 20px 20px 0;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        min-height: calc(100% - 300px);
        background: #fff;
        color: #333;
        // font-size: 30px !important;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
    }
    .question-content > div {
        transition: opacity 0.3s ease;
    }
    .question-content > .disabled {
        user-select: none;
        pointer-events: none;
        opacity: 0.2;
    }
    .question-content > .hide {
        display: none;
    }
    .question-content::-webkit-scrollbar {
        height: 0;
    }

    .question-commit {
        padding: 100px 0;
        width: 100%;
        text-align: center;
        position: relative;

        .commit-btn {
            width: 300px;
            height: 80px;
            line-height: 80px;
            background: #353a51;
            color: #fff;
            border-radius: 40px;
            text-align: center;
            vertical-align: middle;
            display: inline-block;
        }
    }

    // .mint-msgbox {
    //     font-size: 0.3rem !important;
    //     .mint-msgbox-content {
    //         padding: 0.4rem;
    //     }
    //     .mint-msgbox-btns {
    //         height: 0.6rem;
    //         line-height: 0.6rem;
    //     }
    // }
    .mint-msgbox {
        position: absolute;
        top: 50vh;
        left: 50%;
        -webkit-transform: translate3d(-50%, -50%, 0);
        transform: translate3d(-50%, -50%, 0);
        background-color: #fff;
        width: 637.5px;
        box-shadow: 0 0 5px #666;
        border-radius: 3px;
        font-size: 30px;
        -webkit-user-select: none;
        overflow: hidden;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        -webkit-transition: 0.2s;
        transition: 0.2s;
    }
    .mint-msgbox-header {
        padding: 15px 0 0;
    }
    .mint-msgbox-content {
        padding: 30px 30px 35px;
        border-bottom: 1px solid #ddd;
        min-height: 36px;
        position: relative;
    }
    .mint-msgbox-input {
        padding-top: 15px;
    }
    .mint-msgbox-input input {
        border: 1px solid #dedede;
        border-radius: 5px;
        padding: 4px 5px;
        width: 100%;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        outline: none;
    }
    .mint-msgbox-input input.invalid {
        border-color: #ff4949;
    }
    .mint-msgbox-input input.invalid:focus {
        border-color: #ff4949;
    }
    .mint-msgbox-errormsg {
        color: red;
        font-size: 12px;
        min-height: 18px;
        margin-top: 2px;
    }
    .mint-msgbox-title {
        text-align: center;
        padding-left: 0;
        margin-bottom: 0;
        font-size: 32px;
        font-weight: 700;
        color: #333;
    }
    .mint-msgbox-wrapper {
        width: 100%;
        // height: 100%;
    }
    .mint-msgbox-message {
        color: #999;
        margin: 0;
        text-align: center;
        line-height: 36px;
    }
    .mint-msgbox-btns {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 70px;
        line-height: 70px;
    }
    .mint-msgbox-btn {
        line-height: 45px;
        font-size: 30px;
        display: block;
        background-color: #fff;
        -webkit-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        margin: 0;
        border: 0;
    }
    .mint-msgbox-btn:focus {
        outline: none;
    }
    .mint-msgbox-btn:active {
        background-color: #fff;
    }
    .mint-msgbox-cancel {
        width: 50%;
        border-right: 1px solid #ddd;
    }
    .mint-msgbox-cancel:active {
        color: #000;
    }
    .mint-msgbox-confirm {
        color: #26a2ff;
        width: 50%;
    }
    .mint-msgbox-confirm:active {
        color: #26a2ff;
    }
    .msgbox-bounce-enter {
        opacity: 0;
        -webkit-transform: translate3d(-50%, -50%, 0) scale(0.7);
        transform: translate3d(-50%, -50%, 0) scale(0.7);
    }
    .msgbox-bounce-leave-active {
        opacity: 0;
        -webkit-transform: translate3d(-50%, -50%, 0) scale(0.9);
        transform: translate3d(-50%, -50%, 0) scale(0.9);
    }

    // .v-modal-enter {
    //     -webkit-animation: v-modal-in 0.2s ease;
    //     animation: v-modal-in 0.2s ease;
    // }
    // .v-modal-leave {
    //     -webkit-animation: v-modal-out 0.2s ease forwards;
    //     animation: v-modal-out 0.2s ease forwards;
    // }
    // @-webkit-keyframes v-modal-in {
    //     0% {
    //         opacity: 0;
    //     }
    //     100% {
    //     }
    // }
    // @keyframes v-modal-in {
    //     0% {
    //         opacity: 0;
    //     }
    //     100% {
    //     }
    // }
    // @-webkit-keyframes v-modal-out {
    //     0% {
    //     }
    //     100% {
    //         opacity: 0;
    //     }
    // }
    // @keyframes v-modal-out {
    //     0% {
    //     }
    //     100% {
    //         opacity: 0;
    //     }
    // }
    // .v-modal {
    //     position: absolute;
    //     left: 0;
    //     top: 0;
    //     width: 100%;
    //     height: 100%;
    //     opacity: 0.5;
    //     background: #000;
    // }
    .question-result {
        z-index: 100;
        background: transparent;
        background-color: rgba(0, 0, 0, 0.9);
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
    }

    .question-result > .result-panel {
        width: 100%;
        position: absolute;
        left: 0;
        top: 25%;
        text-align: center;
    }

    .question-result > .result-panel > img {
        width: 600px;
        padding: 20px;
    }

    .question-result > .result-panel > .result-title {
        padding: 20px 0 0;
        font-size: 38px;
        font-weight: bold;
        color: #333;
    }
    .question-result > .result-panel > .result-content {
        padding: 20px 0 0;
        font-size: 32px;
        color: #fff;
    }
    .question-result > .result-panel > .result-btn {
        font-size: 36px;
        color: #108ee9;
        padding: 60px 0;
        border-top: 1rpx solid #f6f6f6;
    }
    .mint-cell-wrapper,
    .mint-cell:last-child {
        font-size: 30px !important;
        padding: 0;
        background: none;
    }
    // 上传
    .upload-cell {
        padding: 0.5rem 0.4rem 0;
        .content {
            width: auto;
        }
    }
    .spinner-container {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba($color: #000000, $alpha: 0.2);
        z-index: 999;
        p {
            margin: 0.3rem;
        }
    }
}
</style>